module.exports = __webpack_public_path__ + "static/media/1.187c8efb.svg";